import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

export default function ArticlesGrid() {
  const gridArticles = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              更多爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              海量吃瓜内容持续更新，总有你想看的
            </p>
          </div>
          <Link
            to="/category/shehui-redian"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {gridArticles.map((article) => {
            const category = categories.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group block bg-background-100 rounded-lg overflow-hidden transition-colors hover:bg-background-200/70 cursor-pointer"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    {category && (
                      <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">
                        {category.name}
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万` : article.views}
                    </span>
                    <span>{article.date}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}